import Vue from 'vue'
import VueRouter from 'vue-router'
import WelcomePage from '../components/WelcomePage.vue'
import Dashboard from '../components/Dashboard.vue'
import SurveyManagement from '../components/SurveyManagement.vue'
import DataManagement from '../components/DataManagement.vue'
import EmailTemplates from '../components/EmailTemplates.vue'
import ReportingAnalytics from '../components/ReportingAnalytics.vue'
import UserManagement from '@/components/UserManagement.vue'
import GroupManagement from '../components/GroupManagement.vue'
import StudentHomePage from '@/views/StudentHomePage.vue'
import Logout from '@/views/Logout.vue'
import Unauthorized from '@/views/Unauthorized.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: WelcomePage },
  { path: '/dashboard', component: Dashboard },
  { path: '/surveys', component: SurveyManagement },
  { path: '/data', component: DataManagement },
  { path: '/email-templates', component: EmailTemplates },
  { path: '/reports', component: ReportingAnalytics },
  { path: '/user-management', component: UserManagement },
  { path: '/group-management', component: GroupManagement },
  { path: '/student', component: StudentHomePage },
  { path: '/student/:studentId', component: StudentHomePage },
  { path: '/logout', component: Logout},
  { path: '/unauhorized', component: Unauthorized}
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router

